import { Injectable } from '@angular/core';

import { Api, User } from '../';

@Injectable()
export class assetDocuments {

  constructor(public api: Api, public user:User) { }


  get(params?: any){
    return this.api.get('index.php/asset/documents', params);
  }

  save(params?: any){
    params.created_by = this.user.data.employee_id;
    return this.api.post('index.php/asset/documents', params);
  }

  getDocCalibration(params?: any){
    params.doc_module = 'calibration';
    return this.api.get('index.php/asset/documents', params);
  }

  saveDocCalibration(params?: any){
    params.doc_module = 'calibration';
    params.created_by = this.user.data.employee_id;
    return this.api.post('index.php/asset/documents', params);
  }

}



// WEBPACK FOOTER //
// ./src/providers/asset/documents/documents.ts